/** Inputs for resolving which org slug to send on chat / DWH requests. */
export type ResolveChatOrgInput = {
  /** Org from login (localStorage / JWT) — may be stale when browsing another org path. */
  userOrgName?: string;
  /** Active station slug from the station selector. */
  activeStationId?: string;
  /** Owning org on the selected station row (`org_name` from inventory). */
  stationOrgName?: string;
  /** First URL segment on org-scoped apps, e.g. `phrae` from `/phrae/chat-test`. */
  pathOrgSlug?: string;
};

/**
 * Resolve org_id for chat WebSocket payloads and DWH scoping.
 * Station context and URL path beat stale login org (common on shared UAT host).
 */
export function resolveChatOrgId(input: ResolveChatOrgInput): string {
  const stationOrg = (input.stationOrgName ?? '').trim();
  const pathOrg = (input.pathOrgSlug ?? '').trim();
  const userOrg = (input.userOrgName ?? '').trim();
  const stationId = (input.activeStationId ?? '').trim();

  if (stationOrg) return stationOrg;
  if (pathOrg) return pathOrg;
  if (userOrg) return userOrg;
  return stationId;
}
